import { Dispatch, SetStateAction } from "react";
import MenuItem from "../../common/menu-item/menu-item";
import type { TCaseTag, TColor } from "../../../types/types";
import "./cases-menu.sass";

type CasesMenuRow = {
  id: string | number;
  title: string;
  slug: string | null;
  color?: TColor | null;
  icon?: string;
};

type Props = {
  menuItems: (TCaseTag & { icon?: string })[];
  selected: number | { index: number; slug: string }[];
  setSelected: Dispatch<
    SetStateAction<number | { index: number; slug: string }[]>
  >;
  flexDirection?: "row" | "column";
  className?: string;
};

const CasesMenu = ({
  menuItems: caseTags,
  selected,
  setSelected,
  className,
  flexDirection = "row",
}: Props) => {
  const menuItems: CasesMenuRow[] = [
    { id: "all", title: "Все", slug: null, color: null },
    ...caseTags,
  ];

  const handleItemSelect = (itemIndex: number, slug: string) => {
    setSelected((prevSelected) => {
      const prevArray = Array.isArray(prevSelected) ? prevSelected : [];

      const existingIndex = prevArray.findIndex(
        (item) => item.index === itemIndex && item.slug === slug,
      );

      if (existingIndex !== -1) {
        const newArray = prevArray.filter((_, idx) => idx !== existingIndex);
        return newArray.length > 0 ? newArray : 0;
      }

      return [...prevArray, { index: itemIndex, slug }];
    });
  };

  const isSelected = (itemIndex: number) => {
    if (itemIndex === 0) {
      return (
        selected === 0 || (Array.isArray(selected) && selected.length === 0)
      );
    }

    return Array.isArray(selected)
      ? selected.some((item) => item.index === itemIndex)
      : false;
  };

  return (
    <div className={`cases-menu ${flexDirection}`}>
      {menuItems &&
        menuItems.map((item, index) => (
          <MenuItem
            key={item.id}
            title={item.title}
            color={item.color || undefined}
            isSelected={isSelected(index)}
            setSelected={() =>
              index === 0
                ? setSelected(0)
                : handleItemSelect(index, item.slug as string)
            }
            className={`cases-menu__menu-item ${className}`}
            icon={item.icon}
          />
        ))}
    </div>
  );
};

export default CasesMenu;
